// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,ScoreCard
}                         from '../../../components';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import styles                 from './style';
import ReactDOM from "react-dom";
import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';


import Calendar from "../../../components/EventCalendar/Calendar.js";


class PartnerTournament extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      events : [],
      // events :[{"name":"Corporate Football Championship - Season 2","start_date":"2020-05-01","organizer":"Abin","entries":10},
      //         {"name":"Sporthood Throw ball Championship","start_date":"2020-05-11","organizer":"Abin","entries":5},
      //         {"name":"Corporate Football Championship - Season 3","start_date":"2020-05-21","organizer":"Abin","entries":25},
      //         ],
      showEventCalendar:true,

    };
    
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerTournament');
    
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;
    this.getEventsList();
  }


    getEventsList(){
      console.log("Going to fetch events")
      const url = `${getLocationOrigin()}/tournament/list_events_for_cm/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ events: data.events}))
         .catch(error => error);
    }


  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  onEventCalendarClick(){
    this.setState({showEventCalendar: !this.state.showEventCalendar});
  }
  

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerTournament');
  }


  renderUpcomingEvents(){
    return(
      <table className="table_plain">
        
        <tr>
          <th>Date</th>
          <th>Name</th>
          <th>Organizer</th>
          <th>Entries</th>
        </tr>
        
        
        {

            this.state.events.slice(0, 4).map(
              (eventItem, index) => {
                return (
                  <tr>
                    <td>{eventItem.start_date}</td>
                    <td>{eventItem.name}</td>
                    <td>{eventItem.organizer}</td>
                    <td><span className="label_blue_1">{eventItem.entries}</span></td>
                  </tr>
                );
              }
            )
        }  
          
      </table>
    );
  } 

  renderAllEvents(){
    return(
      <table className="table_plain">
        
        <tr>
          <th>Date</th>
          <th>Name</th>
          <th>Venue</th>
          <th>Organizer</th>
          <th>Entries</th>
          <th>Action</th>
        </tr>
        
        
        {

            this.state.events.map(
              (eventItem, index) => {
                return (
                  <tr>
                    <td>{eventItem.start_date}</td>
                    <td>{eventItem.name.slice(0,30)}</td>
                    <td>{eventItem.venue}</td>
                    <td>{eventItem.organizer}</td>
                    <td><span className="label_blue_1">{eventItem.entries}</span></td>
                    <td>
                      <Link to={"/crud/viewTournament/" + eventItem.id}>
                        <input className="button1" type="button" value="View" />
                      </Link>                    
                    </td>

                  </tr>
                );
              }
            )
        }  
          
      </table>
    );
  }        
  

  render() {
    console.log(this.state.events)

    const {
      statsTable,
      scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

   
    return(
      <div style={styles.container}>
        {/*
        <div className="row">
          <ScoreCard name="score_card_tournament" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>
      */}
        

         <div className="row hot_leads_pipeline" style={{display:'flex',flexDirection:'row'}}>
           <div className="col-md-4">
              <Calendar  />
            </div>
            <div className="col-md-8" style={{overflowX:'auto'}}>
               <div className="heading2 left" style={styles.heading2}>Upcoming Events</div> 
               {this.renderUpcomingEvents()}          
            </div>
         </div>


          <div className="row" style={{'display':"flex",'flexDirection':"row",'marginBottom':"20px"}}>
                <div style = {{'marginRight':"25px"}}>
                  <Link to="./crud/addTournament">
                    <input className="button1" type="button" value="Add Event"    />
                  </Link>
                </div>

                <div style = {{'marginRight':"25px"}}>
                    <input className="button1" type="button" value="Create Quote" />
                
                </div>
          </div>


         <div className="row hot_leads_pipeline">
            <div className="col-md-12 table_container1">
               <div className="heading heading2 left" style={styles.heading2}>List of All Events</div> 
               {this.renderAllEvents()}          
            </div>
         </div>


        


      </div>
    );
  }
}

export default PartnerTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerTournament/PartnerTournament.js